/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Metadata_FileInputs */

const es_admin_traces_metadata_file = /** @type {(inputs: Admin_Traces_Metadata_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo`)
};

const en_admin_traces_metadata_file = /** @type {(inputs: Admin_Traces_Metadata_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

/**
* | output |
* | --- |
* | "File" |
*
* @param {Admin_Traces_Metadata_FileInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_metadata_file = /** @type {((inputs?: Admin_Traces_Metadata_FileInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Metadata_FileInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_metadata_file(inputs)
	return en_admin_traces_metadata_file(inputs)
});
export { admin_traces_metadata_file as "admin.traces.metadata.file" }